import { useTheme, makeStyles, createStyles } from '@material-ui/core/styles';
import { ThemeLib } from '@payface-frontends-libs/theme';
const { typography } = ThemeLib.Generics;
const useStyles = makeStyles((theme) => createStyles({
    '@global': {
        '.apexcharts-tooltip,.apexcharts-xaxistooltip': {
            border: '0 !important',
            boxShadow: `${theme.customShadows.z24} !important`,
            color: `${theme.palette.text.primary} !important`,
            borderRadius: `${theme.shape.borderRadiusSm}px !important`,
            backgroundColor: `${theme.palette.background.default} !important`,
        },
        '.apexcharts-tooltip-title': {
            border: '0 !important',
            fontWeight: theme.typography.fontWeightBold,
            backgroundColor: `${theme.palette.grey[50016]} !important`,
            color: theme.palette.text[theme.palette.mode === 'light' ? 'secondary' : 'primary'],
        },
        '.apexcharts-xaxistooltip-bottom': {
            '&:before': {
                borderBottomColor: 'transparent !important',
            },
            '&:after': {
                borderBottomColor: `${theme.palette.background.paper} !important`,
            },
        },
        '.apexcharts-legend': {
            padding: '0 !important',
        },
        '.apexcharts-legend-series': {
            alignItems: 'center',
            display: 'flex !important',
        },
        '.apexcharts-legend-marker': {
            marginTop: '2px !important',
            marginRight: '8px !important',
        },
        '.apexcharts-legend-text': {
            lineHeight: '18px',
            textTransform: 'capitalize',
        },
    },
}));
export function BaseOptionChart() {
    useStyles();
    const theme = useTheme();
    const LABEL_TOTAL = {
        show: true,
        label: 'Total',
        color: theme.palette.text.secondary,
        ...typography.subtitle2,
    };
    const LABEL_VALUE = {
        offsetY: 8,
        color: theme.palette.text.primary,
        ...typography.h3,
    };
    return {
        colors: [
            theme.palette.primary.main,
            theme.palette.warning.main,
            theme.palette.error.main,
            theme.palette.info.main,
            theme.palette.success.main,
        ],
        chart: {
            defaultLocale: 'pt-br',
            locales: [
                {
                    name: 'pt-br',
                    options: {
                        months: [
                            'Janeiro',
                            'Fevereiro',
                            'Março',
                            'Abril',
                            'Maio',
                            'Junho',
                            'Julho',
                            'Agosto',
                            'Setembro',
                            'Outubro',
                            'Novembro',
                            'Dezembro',
                        ],
                        shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                        days: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
                        shortDays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
                        toolbar: {
                            download: 'Download SVG',
                            selection: 'Seleção',
                            selectionZoom: 'Seleção de Zoom',
                            zoomIn: 'Zoom In',
                            zoomOut: 'Zoom Out',
                            pan: 'Zoom Panorâmico',
                            reset: 'Reset Zoom',
                        },
                    },
                },
            ],
            toolbar: { show: false },
            zoom: { enabled: false },
            foreColor: theme.palette.text.disabled,
            fontFamily: theme.typography.fontFamily,
        },
        states: {
            hover: {
                filter: {
                    type: 'lighten',
                    value: 0.04,
                },
            },
            active: {
                filter: {
                    type: 'darken',
                    value: 0.88,
                },
            },
        },
        fill: {
            opacity: 1,
            gradient: {
                type: 'vertical',
                shadeIntensity: 0,
                opacityFrom: 0.4,
                opacityTo: 0,
                stops: [0, 100],
            },
        },
        dataLabels: { enabled: false },
        stroke: {
            width: 3,
            curve: 'smooth',
            lineCap: 'round',
        },
        grid: {
            strokeDashArray: 3,
            borderColor: theme.palette.divider,
        },
        xaxis: {
            axisBorder: { show: false },
            axisTicks: { show: false },
        },
        markers: {
            size: 0,
            strokeColors: theme.palette.background.paper,
        },
        tooltip: {
            x: {
                show: false,
            },
        },
        legend: {
            show: true,
            fontSize: '13',
            position: 'top',
            horizontalAlign: 'right',
            markers: { radius: 12 },
            itemMargin: { horizontal: 12 },
            labels: {
                colors: theme.palette.text.primary,
            },
        },
        plotOptions: {
            pie: {
                donut: {
                    labels: {
                        show: true,
                        value: LABEL_VALUE,
                        total: LABEL_TOTAL,
                    },
                },
            },
            radialBar: {
                track: {
                    strokeWidth: '100%',
                    background: theme.palette.grey[50016],
                },
                dataLabels: {
                    value: LABEL_VALUE,
                    total: LABEL_TOTAL,
                },
            },
            radar: {
                polygons: {
                    strokeWidth: '1',
                    fill: { colors: ['transparent'] },
                    strokeColors: theme.palette.divider,
                    connectorColors: theme.palette.divider,
                },
            },
        },
    };
}
//# sourceMappingURL=BaseOptionChart.js.map